module.exports = __webpack_public_path__ + "static/img/1uav5.ec7031a0.png";